import React from "react";
import { AlertTriangle, RefreshCw, ChevronDown, ChevronUp } from "lucide-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, showDetails: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
          <div className="max-w-md w-full border-4 border-black bg-white p-8 text-center">
            <AlertTriangle className="w-16 h-16 mx-auto mb-4 text-red-500" />
            <h2 className="text-2xl font-bold mb-2">Something went wrong</h2>
            <p className="text-gray-600 mb-6 text-sm">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 px-6 py-3 bg-purple-600 text-white font-bold border-2 border-black hover:opacity-90"
              data-testid="error-boundary-refresh"
            >
              <RefreshCw size={18} />
              REFRESH PAGE
            </button>
            
            {this.state.error && (
              <div className="mt-6 text-left">
                <button
                  onClick={() => this.setState(prev => ({ showDetails: !prev.showDetails }))}
                  className="flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 mx-auto"
                >
                  {this.state.showDetails ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                  {this.state.showDetails ? 'Hide' : 'Show'} Error Details
                </button>
                {this.state.showDetails && (
                  <div className="mt-2 p-3 bg-gray-100 border border-gray-300 rounded text-xs font-mono overflow-auto max-h-40 text-left">
                    <p className="text-red-600 font-bold">{this.state.error?.toString()}</p>
                    {this.state.errorInfo?.componentStack && (
                      <pre className="mt-2 text-gray-500 whitespace-pre-wrap">{this.state.errorInfo.componentStack.substring(0, 500)}</pre>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
